export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_JWT = 'LOGIN_USER_JWT'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const LOGOUT_USER = 'LOGOUT_USER'
export const USER_ME = 'USER_ME'
export const VERIFY_LOGIN_CREDENTIALS = 'VERIFY_LOGIN_CREDENTIALS'
